import React from 'react';
import { Col, ControlLabel, Row, Well, FormGroup, HelpBlock } from 'react-bootstrap';
import FieldGroup from '../../../components/FieldGroup';
import Datetime from 'react-datetime';
import HoursMinutesInput from '../../../components/HoursMinutesInput/index';

const DelayInfo = ({
    delayForm,
    isEditable,
    validations,
    handleChange,
    handleDateChange,
    handleTimeChange,
}) => (
    <Well>
        <Row>
            <Col sm={6}>
                <HoursMinutesInput
                    name="currentDelay"
                    type="text"
                    label="Current delay (hh:mm) *"
                    initTime={delayForm.currentDelay}
                    placeholder="e.g. 01:23"
                    min="0"
                    maxLength="1000"
                    onTimeChange={handleTimeChange('currentDelay')}
                    errorMessage={validations.currentDelay}
                    readOnly={!isEditable}
                    horizontal
                />
                <FormGroup
                    controlId="etaToEmc"
                    validationState={validations.etaToEmc ? 'error' : null}
                >
                    <Row style={{ marginBottom: 10 }}>
                        <Col componentClass={ControlLabel} sm={4} style={{ marginTop: 10 }}>
                            ETA at CD/EMC *
                        </Col>
                        <Col sm={8} style={{ marginTop: 5 }}>
                            {isEditable ? (
                                <span>
                                    <Datetime
                                        value={delayForm.etaToEmc}
                                        onChange={handleDateChange('etaToEmc')}
                                        dateFormat="DD-MM-YYYY"
                                        timeFormat="HH:mm"
                                        inputProps={{ maxLength: 255 }}
                                        className={validations.etaToEmc && 'datetime-error'}
                                    />
                                    <HelpBlock>{validations.etaToEmc}</HelpBlock>
                                </span>
                            ) : (
                                <p style={{ marginTop: 5 }}>
                                    {delayForm.etaToEmc.format('DD-MM-YYYY HH:mm') || '-'}
                                </p>
                            )}
                        </Col>
                    </Row>
                </FormGroup>
                <FieldGroup
                    id="kmToNextPoint"
                    name="kmToNextPoint"
                    type="text"
                    label="Distance to next logistic point"
                    value={delayForm.kmToNextPoint}
                    addon="km"
                    placeholder="0"
                    min="0"
                    maxLength="1000"
                    onChange={handleChange}
                    errorMessage={validations.kmToNextPoint}
                    readOnly={!isEditable}
                    horizontal
                />
            </Col>
            <Col sm={6}>
                <HoursMinutesInput
                    name="driverTimeLeft"
                    type="text"
                    label="Driver driving time left (hh:mm)"
                    initTime={delayForm.driverTimeLeft}
                    placeholder="e.g. 01:23"
                    min="0"
                    maxLength="1000"
                    onTimeChange={handleTimeChange('driverTimeLeft')}
                    errorMessage={validations.driverTimeLeft}
                    readOnly={!isEditable}
                    horizontal
                />
                <HoursMinutesInput
                    name="driverWorkingTime"
                    type="text"
                    label="Driver working time left (hh:mm)"
                    initTime={delayForm.driverWorkingTime}
                    placeholder="e.g. 01:23"
                    min="0"
                    maxLength="1000"
                    onTimeChange={handleTimeChange('driverWorkingTime')}
                    errorMessage={validations.driverWorkingTime}
                    readOnly={!isEditable}
                    horizontal
                />
            </Col>
        </Row>
    </Well>
);

export default DelayInfo;
